// extracted by mini-css-extract-plugin
export default {"section-container":"Section_section-container__ak7By"};